<div class="tablist-group">
  @for (tab of tabList; track $index) {
    <div class="tab" [class.active]="activeTabId === tab?.id" (click)="setActiveTab(tab)">
      <span>{{ tab?.label }}</span>
    </div>
  }
</div>
